// extracted by mini-css-extract-plugin
export default {"container":"Title-module__container--dQS4K","header":"Title-module__header--PxCgZ","expandButton":"Title-module__expandButton--zzl6c"};